var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manager_dashboard" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _vm.checkIsManager()
            ? _c("ManagerSidebarMenu", {
                attrs: {
                  show_menu: false,
                  show_back_button: true,
                  back_link: "managerReports"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.checkIsMentor()
            ? _c("ManagerSidebarMenu", {
                attrs: {
                  show_menu: false,
                  show_back_button: true,
                  back_link: "mentorReports"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content-wrapper",
              staticStyle: { "padding-left": "165px" }
            },
            [
              _c("div", { staticClass: "container-wrapper center ml-2" }, [
                _c("div", { staticClass: "row mt-3 mb-3 border-bottom pb-2" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "col" }, [
                    _vm.results.length > 0
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-top": "2px",
                              float: "right",
                              "margin-left": "15px"
                            },
                            on: {
                              click: function($event) {
                                return _vm.shareButtonModal()
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticStyle: { cursor: "pointer" },
                              attrs: {
                                src: require("@/assets/Send_Report_Button.svg"),
                                alt: "MentorMentee",
                                width: "24px"
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.results.length > 0
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-left": "15px",
                              "margin-top": "2px",
                              float: "right",
                              "margin-right": "0px"
                            },
                            on: {
                              click: function($event) {
                                return _vm.exportCSVAction()
                              }
                            }
                          },
                          [
                            _vm.results.length > 0
                              ? _c("img", {
                                  staticStyle: { cursor: "pointer" },
                                  attrs: {
                                    src: require("@/assets/Download_Report.svg"),
                                    alt: "MentorMentee",
                                    width: "24px"
                                  }
                                })
                              : _vm._e()
                          ]
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        staticClass: "loading_show"
                      },
                      [_c("div", { staticClass: "spinner-border text-danger" })]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.results, function(result, rindex) {
                      return _c(
                        "div",
                        { key: rindex, staticClass: "row report_view" },
                        [
                          _c("div", { staticClass: "field_1" }, [
                            _vm._v(_vm._s(parseInt(rindex + 1)))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "field_2" }, [
                            _vm._v(_vm._s(result.accountName))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "field_3 text-align-center" },
                            [_vm._v(_vm._s(result.managerCount))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "field_4 text-align-center" },
                            [_vm._v(_vm._s(result.mentorCount))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "field_5 text-align-center" },
                            [_vm._v(_vm._s(result.menteeCount))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "field_6 text-align-center" },
                            [_vm._v(_vm._s(result.repsReviewCount))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "field_7 text-align-center" },
                            [_vm._v(_vm._s(result.repsAddedCount))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "field_8 text-align-center" },
                            [_vm._v(_vm._s(result.competencyEarnedCount))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "field_9 text-align-center" },
                            [_vm._v(_vm._s(result.inactivementeeCount))]
                          ),
                          _vm._v(" "),
                          _vm._m(2, true)
                        ]
                      )
                    })
                  ],
                  2
                )
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ShareReportModal",
        {
          attrs: { isModalVisible: _vm.isModalVisible },
          on: {
            close: function($event) {
              _vm.isModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("h3", [_vm._v("Share Report")])]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "body" }, slot: "body" }, [
            _vm.showShareSuccess == true
              ? _c(
                  "div",
                  {
                    staticClass: "col-12 override-padding",
                    staticStyle: {
                      color: "#68C47E",
                      "text-align": "center",
                      "margin-bottom": "15px"
                    }
                  },
                  [_c("b", [_vm._v("Report shared successfully!")])]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 override-padding" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.share_email,
                    expression: "share_email"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|email",
                    expression: "'required|email'"
                  }
                ],
                staticClass: "col-lg-12 input-text form-control",
                staticStyle: { "line-height": "30px" },
                attrs: {
                  name: "share_email",
                  placeholder: "Enter Email...",
                  "data-vv-as": "Email address",
                  maxlength: "255"
                },
                domProps: { value: _vm.share_email },
                on: {
                  keyup: function($event) {
                    return _vm.checkEmail()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.share_email = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.verrors.has("share_email"),
                      expression: "verrors.has('share_email')"
                    }
                  ],
                  staticClass: "validate-warning-msg"
                },
                [_vm._v(_vm._s(_vm.verrors.first("share_email")))]
              )
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "margin-bottom-10",
              staticStyle: { clear: "both" }
            }),
            _vm._v(" "),
            _vm.showWait == false
              ? _c(
                  "div",
                  { staticClass: "col-12 override-padding text-align-right" },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-red col-3 input-height-25 createBtn",
                        staticStyle: {
                          "line-height": "30px",
                          "border-radius": "10px"
                        },
                        attrs: { disabled: _vm.share_button_disable },
                        on: {
                          click: function($event) {
                            return _vm.shareButtonSubmit()
                          }
                        }
                      },
                      [_c("b", [_vm._v(_vm._s(_vm.submit_text))])]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showWait == true
              ? _c(
                  "div",
                  { staticClass: "col-12 override-padding text-align-right" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-dard-grey col-lg-3",
                        staticStyle: {
                          "line-height": "30px",
                          "border-radius": "10px"
                        },
                        attrs: { disabled: "true" }
                      },
                      [_c("b", [_vm._v("Please wait...")])]
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "col-3 override-padding",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "BatchModal",
        {
          attrs: { isModalVisible: _vm.isExportModalVisible },
          on: {
            close: function($event) {
              _vm.isExportModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "sub-heading",
            attrs: { slot: "header" },
            slot: "header"
          }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "body" }, slot: "body" }, [
            _c("div", {}, [
              _c("div", { staticClass: "export-details" }, [
                _vm._v(
                  "\n          Exported: " +
                    _vm._s(_vm.rowsExportedCSV) +
                    " of " +
                    _vm._s(_vm.rowsCSV) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "percentage-text" }, [
                _vm._v("\n          " + _vm._s(_vm.percentage) + "\n        ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "batch-box" }, [
                _c(
                  "div",
                  {
                    staticClass: "batch-loading",
                    attrs: { id: "batch-loading" }
                  },
                  [_vm._v("\n             \n          ")]
                )
              ]),
              _vm._v(" "),
              _vm.percentage == "100%"
                ? _c(
                    "div",
                    {
                      staticClass: "download-link",
                      on: {
                        click: function($event) {
                          return _vm.downloadFunc()
                        }
                      }
                    },
                    [_vm._v("\n          Download CSV File\n        ")]
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "col-3 override-padding",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("div", { staticClass: "h4 text-uppercase" }, [_vm._v("Usage Report")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row report_heading" }, [
      _c("div", { staticClass: "field_1" }, [_vm._v("No")]),
      _vm._v(" "),
      _c("div", { staticClass: "field_2" }, [_vm._v("Account Name")]),
      _vm._v(" "),
      _c("div", { staticClass: "field_3" }, [_vm._v("Number of Managers")]),
      _vm._v(" "),
      _c("div", { staticClass: "field_4" }, [_vm._v("Number of Mentors")]),
      _vm._v(" "),
      _c("div", { staticClass: "field_5" }, [_vm._v("Number of Mentees")]),
      _vm._v(" "),
      _c("div", { staticClass: "field_6" }, [_vm._v("Reps to Review")]),
      _vm._v(" "),
      _c("div", { staticClass: "field_7" }, [_vm._v("Reps Recorded")]),
      _vm._v(" "),
      _c("div", { staticClass: "field_8" }, [_vm._v("Competencies Earned")]),
      _vm._v(" "),
      _c("div", { staticClass: "field_9" }, [_vm._v("Inactive Mentees")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "custom_heading_hr" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "custom_hr" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43ef6adf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43ef6adf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manager/usage_reports.vue
// module id = null
// module chunks = 